<template>
  <SidePanel
    :isVisible="true"
    :leftCommand="showLeftCommand"
    @save="onCancel"
    @cancel="onCancelContacts"
    :cancel="$t('general.cancel')"
    :header="headerText"
    :rightCommand="true"
    :save="rightLabel"
  >
    <div class="sidepanel-body pt-1">
      <NavigationTabs
        v-if="!contactMode"
        v-model="currentTabComponent"
        :navItems="navItems"
      />

      <div class="invite-section">
        <!-- start of contact selection -->
        <div v-if="isContactMode">
          <template v-if="contacts.length == 0">
            <div class="no-contacts mt-4" v-html="getContactDescription"></div>
          </template>
          <template v-else>
            <select-contacts
              :contacts="contacts"
              @removeAllSelected="removeAllSelectedContact()"
              @selectAllContacts="selectAllContacts()"
              @toggleContactSelect="(contact) => toggleContactSelect(contact)"
            />
          </template>
        </div>
        <!-- end of contact selection-->

        <!-- start of contact selection -->
        <div v-if="isPollMode">
          <select-poll
            @selectPoll="(poll) => selectContactsFromPoll(poll)"
            :contacts="contacts"
            :polls="polls"
          />
        </div>
        <!-- end of contact selection-->

        <!-- start of poll contact selection -->
        <div v-if="isPollContactsMode">
          <select-poll-contacts
            :poll="selectedPoll"
            @toggleContactSelect="(contact) => togglePollContactSelect(contact)"
            @selectContactSelect="(contact) => selectContactSelect(contact)"
            :mycontacts="contacts"
          />
        </div>
        <!-- end of poll contact selection-->

        <div v-if="isInviteMode">
          <template v-if="currentTabComponent == 'share-link'">
            <!-- start public invitation -->

            <div class="font-weight-500 mt-15">
              {{ $t('invite.shareLinkDescription') }}
            </div>

            <div class="d-flex">
              <div class="invite-public-link-box mt-15 mb-2">
                <span class="text-truncate poll-url mb-2">{{ pollUrl }}</span>
                <span
                  class="invite-copy text-primary font-weight-bold pointer"
                  v-clipboard:copy="pollUrl"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onCopyError"
                >
                  <Btn
                    @click.native="inviteEmails"
                    :label="$t('invite.copyUrl')"
                  />
                </span>
              </div>
              <div class="qr-block">
                <qrcode-vue class="qr-block-canvas" id="qr-canvas" :value="pollUrl" size="50"></qrcode-vue>
                <BtnLink
                  @click.native="saveQRAsImage()"
                  :label="$t('invite.downloadQRCode')"
                  labelCustomClass="mt--5 font-size-10"
                  />
              </div>
            </div>

            <div v-if="showCopySuccess" class="text-success">
              {{ $t('invite.copyUrlSuccess') }}
            </div>
            <div v-if="showCopyError" class="text-error">
              {{ $t('invite.copyUrlError') }}
            </div>

            <div class="email-recommended mt-2">
              <input
                type="checkbox"
                class="mandatory-email"
                v-model="mandatoryEmail"
              />
              <label for="checkbox" class="ml-2">{{
                $t('options.mandatoryEmail')
              }}</label>
            </div>

            <ShowDetails
              :headerText="inviteLinkheaderDisplayText"
              :details="$t('invite.usingPublicLinkDetails')"
              :collapsable="true"
              :customClass="'font-color-style'"
              @change="getInviteLinkHeaderText($event)"
            />
            <!-- <div class="font-weight-bold mt-1">
              {{ $t('invite.publicLinkNote2') }}
            </div> -->
          </template>
          <!-- end public  invitation -->
          <template v-else>
            <div class="font-weight-500 mt-15">
              {{ $t('invite.emailInviteDescription') }}
            </div>

            <div class="border-envelope mb-0">
              <div class="mt-2">
                <div class="form-group">
                  <label for="subject" class="mb-0">
                    <span class="font-weight-600">
                      {{ $t('invite.subject') }}
                    </span>
                    <span v-if="!isAuthenticated" class="text-szie-12">
                      {{ $t('invite.forAuthenticatedOnly') }}
                    </span>
                  </label>
                  <textarea
                    id="subject"
                    class="form-control"
                    :disabled="!isAuthenticated"
                    cols="50"
                    rows="1"
                    v-model="subject"
                  ></textarea>
                </div>
                <label for="message" class="mb-0">
                  <span class="font-weight-600">
                    {{ $t('invite.message') }}
                  </span>
                  <span v-if="!isAuthenticated" class="text-szie-12">
                    {{ $t('invite.forAuthenticatedOnly') }}
                  </span>
                </label>
                <div class="invite-user-message-box">
                  <div class="form-group">
                    <textarea
                      id="message"
                      :disabled="!isAuthenticated"
                      class="form-control text-size-14"
                      cols="50"
                      rows="4"
                      v-model="message"
                    ></textarea>
                    <div class="link-warning text-center text-font-size-12 text-weight-semi-bold">{{$t('invite.linkWarning')}}</div>
                  </div>
                  <!-- <div class="project-link">
                    <span>
                      {{
                        $t('invite.projectLink', { projectLink: poll.title })
                      }}
                    </span>
                    <button disabled="disabled" class="btn btn-secondary btn-sm">
                    {{ $t('invite.persLink') }}
                    </button>
                  </div>
                  <div class="form-group">
                    {{ $t('invite.kulibriTeam') }}
                  </div> -->
                </div>
              </div>
            </div>

            <!-- contact invitation -->
            <div class="recipients mb-2">
              <div class="invite-message-link mb-0">
                <span class="font-weight-600">{{
                  $t('invite.participantsLabel')
                }}</span>
              </div>

              <!-- <div class="text-size-14"> {{ $t('invite.personalizedInvitationsOption') }} </div> -->
              <div class="links text-right">
                <div
                  class="select-contacts-link pointer mb-0"
                  @click="toggleContactMode"
                >
                  <span
                    >{{ $t('invite.chooseFromContacts') }}
                    <!-- <font-awesome-icon
                  class="mr-1 ml-1"
                  :icon="['fal', 'user-friends']"
                /> -->
                    <font-awesome-icon
                      class="mr-1 ml-1"
                      :icon="['fal', 'chevron-right']"
                  /></span>
                </div>
                <div
                  v-if="1"
                  class="select-contacts-link pointer mb-2"
                  @click="showProjectMode"
                >
                  <span class="text-weight-semi-bold">
                    <label class="col-2 col-form-label new-premium-label">
                      New
                    </label>
                    <img
                      class="ml-1 mr-2 flex-column border-radius premium-logo-design"
                      height="50"
                      srcset="/images/PremiumFavicon.png"
                      alt=""
                    />
                  </span>
                  {{ $t('invite.chooseFromPolls') }}
                  <font-awesome-icon
                    class="mr-1 ml-1"
                    :icon="['fal', 'user-friends']"
                  />
                  <font-awesome-icon
                    class="mr-1 ml-1"
                    :icon="['fal', 'chevron-right']"
                  />
                </div>
              </div>
            </div>

            <div v-if="selectedContacts.length > 0">
              <div class="font-weight-bold mt-2 selected-contact-list">
                <div class="display-left">
                  {{
                    $t('invite.selected') + ' (' + selectedContacts.length + ')'
                  }}
                </div>
                <div
                  class="display-right remove-all"
                  @click="removeAllSelectedContact()"
                >
                  {{ $t('invite.removeAll') }}
                </div>
              </div>
              <div class="contacts-box selected mb-2">
                <div
                  class="selected-item"
                  v-for="contact in selectedContacts"
                  :key="contact.id"
                >
                  <strong>{{ contact.name }}</strong>
                  {{ ' &lt;' + contact.email + '&gt;' }}
                  <font-awesome-icon
                    class="ml-3 pointer"
                    :icon="['fal', 'trash-alt']"
                    @click="toggleContactSelect(contact)"
                  />
                </div>
              </div>
            </div>

            <div class="font-weight-bold">
              <div class="display-left text-size-14">
                {{ $t('invite.addNewContact') + ' (' + mailCount + ')' }}
              </div>
              <div
                class="mr-1 display-right remove-all"
                @click="removeAllContact()"
              >
                {{ $t('invite.removeAll') }}
              </div>
            </div>

            <div class="form-group">
              <textarea
                id="newMails"
                cols="30"
                rows="4"
                role="email"
                type="email"
                class="form-control inserted-contact"
                :placeholder="$t('invite.addNew')"
                v-model="newMails"
              ></textarea>
              <p v-if="emailError" class="text-danger"> {{ emailError }} </p>
            </div>

            <div class="mt-3 mb-4">
              <Btn
                @click.native="inviteEmails"
                :label="
                  $t('invite.sendInvitations') +
                  displayEmailAndSelectedContactCountInButton
                "
                :loading="isLoading"
                :fullWidth="true"
                :disabled="isDisabled"
              />
              <p class="invite-ack mt-1 mb-0" v-if="sentMailAcknowledgement">
                {{ sentMailAcknowledgement }}
              </p>

              <ShowDetails
                :headerText="headerDisplayText"
                :details="$t('invite.showMoreContent')"
                :collapsable="true"
                :customClass="'font-color-style align-center'"
                @change="getPersonalizedInvitationHeaderText($event)"
              />
            </div>
          </template>
          <!-- end contact invitation -->
        </div>
        <!-- Some special link for the admin user  -->

        <div v-if="isInviteMode" class="section-links">
          <div class="panel-section-header text-panel-section-header">
            {{ $t('invite.sectionLinks') }}
          </div>
          <div>
            <div class="invitation-link my-2" v-if="!isSubAdmin">
              <p class="text-dark-grey">{{ $t('invite.adminLink') }}</p>
              <span>{{ pollAdminUrl }}</span>
            </div>

            <template v-if="invitations.length > 0">
              <div class="invitation-link mt-3 mb-1">
                <p class="text-dark-grey">
                  {{ $t('invite.participantsLinks') }}:
                </p>
              </div>

              <div
                class="invitation-link-description mb-2"
                v-html="$t('invite.invitationLinkYesHtml')"
              ></div>
              <div
                v-for="invitation in invitations"
                :key="invitation.id"
                class="d-flex text-primary p-1 border-bottom k-links"
              >
                <div class="invitation-link">
                  <p>{{ invitation.email }}:</p>
                  <span>{{ invitationUrl }}{{ invitation.id }}</span>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                class="invitation-link-description mb-2"
                v-html="$t('invite.invitationLinkNoHtml')"
              ></div>
            </template>
          </div>
        </div>
      </div>

      <div class="sidepanel-footer"></div>
    </div>
    <ModalPremiumFeatureDialog
      ref="dlgPremiumFeatureDialog"
    />
  </SidePanel>
</template>

<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';
import { HTTP } from '@/shared/http';
import shared from '@/shared.js';
// import ToggleOption from '@/components/Edit/ToggleOption.vue';
import ShowDetails from '@/components/UI/ShowDetails.vue';
import { modalParticipantMixins } from '../mixins/ModalParticipantMixins';
import sortParticipants from '@/shared/sortParticipants';
import NavigationTabs from '@/components/UI/NavigationTabs';
import SelectContacts from '@/components/Edit/SelectContacts';
import SelectPoll from '@/components/Edit/SelectPoll';
import SelectPollContacts from '@/components/Edit/SelectPollContacts';
import ModalPremiumFeatureDialog from '@/components/~Global/Dialogs/ModalPremiumFeatureDialog';

import { mapState, mapGetters } from 'vuex';
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'EditInvites',

  props: [],
  mixins: [modalParticipantMixins],
  components: {
    SidePanel,
    // ToggleOption,
    ShowDetails,
    NavigationTabs,
    SelectContacts,
    SelectPoll,
    SelectPollContacts,
    ModalPremiumFeatureDialog,
    QrcodeVue
  },

  data() {
    return {
      contacts: [],
      polls: [],
      selectedPoll: null,
      selectedContactsArr: [],
      newMails: '',
      subject: 'Um Antwort wird gebeten',
      message: 'Ich bitte Sie an diser Umfrage teilzunehmen!',
      contactMode: 0,
      showMessage: true,
      showCopySuccess: false,
      showCopyError: false,
      // TODO: check if array for selected is needed (different sort order??)

      isLoading: false,
      sentMailAcknowledgement: '',
      headerDisplayText: this.$t('invite.moreAboutPersonalizedInvitations'),
      inviteLinkheaderDisplayText: this.$t('invite.usingEmail'),
      currentTabComponent: 'share-link',
      userMessage: '',
      isSending: false,
    };
  },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
      user: (state) => state.Login.user,
    }),

    ...mapGetters([
      'publicKey',
      'userName',
      'isOwner',
      'isPremium',
      'isAuthenticated',
      'isAdmin',
      'userId',
      'isSubAdmin',
    ]),

    isContactMode() {
      return this.contactMode == 1;
    },

    isPollMode() {
      return this.contactMode == 2;
    },

    isPollContactsMode() {
      return this.contactMode == 3;
    },

    isInviteMode() {
      return this.contactMode == 0;
    },

    showLeftCommand() {
      if (this.contactMode) {
        return false;
      } else {
        return false;
      }
    },

    mandatoryEmail: {
      get() {
        if (this.poll.options.mandatoryEmail == null) return false;
        return this.poll.options.mandatoryEmail;
      },
      set(value) {
        this.$store.commit('updateMandatoryEmail', value);
        this.$store.commit('updateOptions', this.poll.options);
      },
    },

    pollAdminUrl() {
      let url =
        process.env.VUE_APP_FRONTEND_URI +
        '/pr/' +
        this.poll.id +
        '/' +
        this.poll.key;
      return url;
    },

    pollUrl() {
      let url =
        process.env.VUE_APP_FRONTEND_URI +
        '/pr/' +
        this.poll.id +
        '/' +
        this.publicKey;
      return url;
    },

    pollUrlMitko() {
      let url = process.env.VUE_APP_FRONTEND_URI + '/pr/' + this.poll.id;
      return url;
    },

    headerText() {
      switch (this.contactMode) {
        case 0:
          return this.$t('invite.inviteParticipants');
        case 1:
          return this.$t('invite.selectContacts');
        case 2:
          return this.$t('invite.selectPoll');
        case 3:
          return this.$t('invite.selectPollContacts').replace(
            '%s',
            this.selectedPoll.title
          );
      }
      return null;
    },

    rightLabel() {
      if (this.isContactMode || this.isPollContactsMode)
        return this.$t('invite.labelTakeOver');
      return null;
    },

    invitations() {
      const invitations = this.poll.invitations;
      console.error('Invitation:', invitations);
      console.error('Participants:', this.poll.participants);
      return invitations.sort((a, b) => {
        // if(!b.email) {
        //   const p = this.poll.participants.find((p) => p.id ==  b.participant_id) 
        //   console.error( {p} - {b});
        // }
        if( !b.email ) return -1;
        if( !a.email ) return 1;
        a.email.toLowerCase() > b.email.toLowerCase() ? 1 : -1
      }
        
      );
    },

    invitationUrl() {
      let url = process.env.VUE_APP_FRONTEND_URI + '/pr/' + this.poll.id + '/';
      return url;
    },

    filteredContacts: function () {
      let sortKey = this.sortKey || 'name';
      let filterKey = this.searchText && this.searchText.toLowerCase();
      let order = this.sortOrders[sortKey] || 1;
      let contacts = this.contacts;
      let searchKeys = this.searchKeys;
      if (filterKey) {
        contacts = contacts.filter(function (contact) {
          return Object.keys(contact).some(function (key) {
            return (
              searchKeys.includes(key) &&
              String(contact[key]).toLowerCase().indexOf(filterKey) > -1
            );
          });
        });
      }
      if (sortKey) {
        contacts = contacts.slice().sort(function (a, b) {
          a = a[sortKey].toLowerCase();
          b = b[sortKey].toLowerCase();
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      return contacts;
    },
    selectedContacts() {
      this.resetAck();
      // let selected = this.contacts.filter((contact) => contact.selected);
      // let sortKey = 'name';
      // selected = selected.slice().sort(function (a, b) {
      //   a = a[sortKey].toLowerCase();
      //   b = b[sortKey].toLowerCase();
      //   return a === b ? 0 : a > b ? 1 : -1;
      // });
      let selected = this.selectedContactsArr;
      return selected;
    },

    mailCount() {
      let count = 0;
      const separator = this.newMails.indexOf(';') > -1 ? ';' : ',';
      const emails = this.newMails.split(separator);
      for (let i = 0; i < emails.length; i++) {
        if (this.isValidEmail(emails[i])) {
          count++;
        }
      }
      return count;
    },
    displayEmailAndSelectedContactCountInButton() {
      let mailCountLength = this.selectedContacts.length + this.mailCount;
      return mailCountLength > 0 ? ' (' + mailCountLength + ')' : '';
    },

    isDisabled() {
      if (this.isSending) return true;
      // if( this.selectedContacts.length + this.mailCount > 0 ) return true;
      return false;
    },

    getContactDescription() {
      if (this.user) {
        return this.$t('contacts.noContacts');
      }
      return this.$t('contacts.noContactsDescription');
    },
    navItems() {
      let items = [
        {
          code: 'share-link',
          label: this.$t('invite.shareLink'),
          icon: 'link',
        },
        {
          code: 'send-email',
          label: this.$t('invite.shareEmailInvite'),
          icon: 'envelope',
        },
        // { code: 'my-old-contacts', label: 'Old Contacts' },
      ];
      return items;
    },
    projectLinkURL() {
      return this.$t('invite.projectLink', { projectLink: this.poll.title });
    },
  },

  methods: {
    saveQRAsImage() {
      var link = document.createElement('a');
      link.download = this.poll.title + '-qr.png';
      link.href = document.getElementById('qr-canvas').childNodes[0].toDataURL()
      link.click();
    },
    onCancel() {
      console.log('onCancel', this.selectedContactsArr);
      if (this.contactMode > 0) {
        this.contactMode = 0;
      } else {
        this.$emit('cancel');
      }
    },

    onCancelContacts() {
      if (this.contactMode) {
        this.removeAllSelectedContact();
        this.contactMode = false;
      } else {
        this.$emit('cancel');
      }
    },

    toggleContactMode() {
      this.contactMode = !this.isContactMode;
    },

    showContactMode() {
      this.contactMode = 1;
      this.selectedContactsArr = [];
    },

    showProjectMode() {
      if (!this.isPremium) {
        this.$refs.dlgPremiumFeatureDialog.openModal(event);
        return;
      }
      this.contactMode = 2;
      //this.selectedContactsArr = [];
    },

    toggleContactSelect(contact) {
      console.log('toggleContactSelect', contact);
      if (contact.selected) {
        contact.selected = false;
        let index = this.selectedContactsArr.findIndex(
          (item) => item.id === contact.id
        );
        if (index > -1) {
          this.selectedContactsArr.splice(index, 1);
        }
      } else {
        contact.selected = true;
        this.selectedContactsArr.push(contact);
      }
    },

    selectContactSelect(contact) {
      console.log('selectContact', contact);
      contact.selected = true;
      const sameEmailContact = this.selectedContactsArr.find(
        (c) => c.email == contact.email
      );
      if (sameEmailContact == null) {
        console.log('add contact', contact);
        this.selectedContactsArr.push(contact);
      }
    },

    togglePollContactSelect(contact) {
      let index = this.selectedContactsArr.findIndex(
        (item) => item.id === contact.id
      );

      if (index > -1) {
        this.selectedContactsArr.splice(index, 1);
      } else {
        this.selectedContactsArr.push(contact);
      }
      console.log('toggleContactSelect', contact, this.selectedContactsArr);
    },

    selectContactsFromPoll(poll) {
      console.log('selectContactsFromPoll:', poll);
      this.contactMode = 3;
      this.selectedPoll = poll;
    },

    isValidSelection() {
      const constantsSelected = this.selectedContacts.length != 0;
      const emailesEnetred = this.newMails != '';
      if (emailesEnetred || constantsSelected) return true;
      return false;
    },

    inviteEmails() {

      // check for <link> placeholder
      if( !this.message.includes("<Link>") ){
        console.error("<Link> placeholder not found");
        return;
        }


      var emailList = [];

      if (this.newMails.length > 3) {
        emailList = this.newMails
          .split(';')
          .flatMap((e) => e.split(','));
      }

      let validEmails = emailList.filter(email => this.isValidEmail(email));

      if(validEmails.length != emailList.length) {
        this.emailError = this.$t("invite.emailInvitationError");
      }

      //console.log(emailList)

      const nmbOfParticipants =
        this.poll.participants.length +
        validEmails.length +
        this.selectedContacts.length;
      const limit = 100;

      const limitReached = nmbOfParticipants > limit;
      console.info(
        'Limit check:',
        nmbOfParticipants,
        this.poll.participants.length,
        validEmails.length,
        this.selectedContacts.length,
        limitReached,
        validEmails
      );

      validEmails = validEmails.join(",");

      if (!this.isPremium && limitReached) {
        this.sentMailAcknowledgement = this.$t('invite.limitReached');
        window.setTimeout(() => {
          // this time will used to display the invitation Acknowledgement
          this.contacts = this.contacts.map((c) =>
            c.selected === true ? { ...c, selected: false } : c
          );
          // this.newMails = '';
          // this.selectedContactsArr = [];
          this.isSending = false;
          this.sentMailAcknowledgement = '';
        }, 2000);

        return;
      }
      let invitations = {
        id: this.poll.id,
        subject: this.subject,
        message: this.message,
        message1: this.message1,
        emails: validEmails,
        contacts: this.selectedContacts,
        receiveCommentReminder: true,
        selfRegistration: false,
        locale: this.user ? this.user.locale : this.$i18n.locale,
      };
      console.log('invitations', invitations);
      this.isLoading = true;
      this.resetAck();

      this.isSending = true;

      this.$store.dispatch('sendInvitations', invitations).then(() => {
        this.isLoading = false;

        // mark new invitae contacts as already participating

        for (const contact of this.selectedContacts) {
          contact.isParticipant = true;
        }

        console.log(
          'Send via HTTP private emails to invited participants:' +
            validEmails
        );

        let participants = this.identifyCurrentUser(this.poll.participants);
        sortParticipants(participants, this.userId);
        this.$store.commit('updateParticipants', participants);

        this.newMails = '';
        this.emailError = "";
        this.sentMailAcknowledgement = this.$t(
          'invite.invitationAcknowledgement'
        );

        window.setTimeout(() => {
          // this time will used to display the invitation Acknowledgement
          this.contacts = this.contacts.map((c) =>
            c.selected === true ? { ...c, selected: false } : c
          );
          this.selectedContactsArr = [];
          this.isSending = false;
        }, 2000);
      });
    },

    onCopy() {
      this.showCopySuccess = true;
      window.setTimeout(() => {
        this.showCopySuccess = false;
      }, 5000);
    },

    onCopyError() {
      this.showCopySuccess = true;
      window.setTimeout(() => {
        this.showCopySuccess = false;
      }, 5000);
    },

    resetAck() {
      this.sentMailAcknowledgement = '';
    },
    removeAllContact() {
      this.newMails = '';
    },

    selectAllContacts() {
      console.log('selectAllContacts');
      this.contacts.forEach((c) => {
        if (!c.isParticipant) {
          c.selected = true;
          this.selectedContactsArr.push(c);
        }
      });
    },

    removeAllSelectedContact() {
      console.log('removeAllSelected');
      this.contacts.forEach((c) => (c.selected = false));
      this.selectedContactsArr = [];
      // this.filteredContacts.map((child) => {
      //   this.contacts = this.contacts.map((c) => {
      //     if (child.id == c.id) {
      //       let temp = { ...c, selected: false };
      //       return temp;
      //     }
      //     return c;
      //   });
      // });
    },
    getPersonalizedInvitationHeaderText(value) {
      this.headerDisplayText =
        value == false
          ? this.$t('invite.moreAboutPersonalizedInvitations')
          : this.$t('invite.less');
    },
    getInviteLinkHeaderText(value) {
      this.inviteLinkheaderDisplayText =
        value == false ? this.$t('invite.usingEmail') : this.$t('invite.less');
    },
  },

  created() {
    this.getInitials = shared.getInitials;
    this.isValidEmail = shared.isValidEmail;
    this.emailError = "";
  },

  mounted() {
    let creatorName = this.userName;
    if (!creatorName && !this.isAuthenticated) {
      creatorName = this.poll.user.name;
    }
    this.subject = this.$t('invite.subjectText', {
      userName: creatorName,
      pollTitle: '„' + this.poll.title + '“',
    });



    this.message = this.$t('invite.messageText', {
      userName: creatorName,
      pollTitle: '„' + this.poll.title + '“',
      email: this.poll.user.email,
      pollUrl: '<Link>'
    });

    console.info("message:", this.message);

    this.message1 = this.$t('invite.messageStartNew');

    if (!this.isAuthenticated) {
      console.log('mount completed for unauthenticated user');
      return;
    }
    const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
    const url = apiUrl + '/contacts';
    console.log('Using the followingUrl:' + url);

    const contactsLoaded = localStorage.getItem('contacts');
    if (contactsLoaded) {
      console.log('read contacts from local storage');
      this.contacts = JSON.parse(contactsLoaded);
    }

    const pollsLoaded = localStorage.getItem('own-polls');
    if (pollsLoaded) {
      this.polls = JSON.parse(pollsLoaded);
    }

    const myPollsUrl = apiUrl + '/ownpolls';
    HTTP.get(myPollsUrl)
      .then((response) => {
        this.polls = response.data;
        console.log('Own polls loaded:', this.polls);
        localStorage.setItem('own-polls', JSON.stringify(this.polls));
      })
      .catch((error) => console.log(error));

    HTTP.get(url)
      .then((response) => {
        console.log('Processing the loaded contacts:', response);
        this.contacts = response.data.map((contact) => {
          let found = false;
          for (let i = 0; i < this.poll.participants.length; i++) {
            if (
              this.poll.participants[i]['user'] &&
              this.poll.participants[i]['user']['email'] &&
              contact.email == this.poll.participants[i]['user']['email']
            ) {
              found = true;
              break;
            }
          }
          contact.isParticipant = found;
          contact.selected = false;
          return contact;
        });
        localStorage.setItem('contacts', JSON.stringify(this.contacts));
      })
      .catch((error) => console.log(error));

    console.log('mount completed');
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/style';

.select-contacts-link {
  color: $primary;
  font-size: $small;
  font-weight: $medium-weight;
}

.more-info {
  color: $primary;
  font-size: $small;
  font-weight: $medium-weight;
  cursor: pointer;
}

.panel-section-header {
  background-color: rgba(0, 0, 0, 0.8);
  padding: 8px 16px;
  margin-bottom: 8px;
  margin-top: 8px;
  line-height: 20px;
  margin-left: -15px;
  margin-right: -15px;
}

.invite-message-link {
  color: $dark-grey;
  font-size: $small;
  font-weight: $medium-weight;
}

.project-link {
  color: $personalized-link-color;
  font-size: $small;
  font-weight: $medium-weight;
  white-space: pre-line;
}
.border-envelope {
  padding: 5px;
  background-image: url(/images/envelope-border.png);
  background-position: 0 100%;
  background-repeat: repeat-x, repeat-y;
  background-size: 40px 3px;
  padding-left: 0px;
}

.invite-message-box {
  background-color: $mid-grey;
  color: white;
  border-radius: 0px;
  padding: 8px;
  border-radius: 5px;
}

.invite-public-link-box {
  display: grid;
  .poll-url {
    border: solid 1px;
    align-self: center;
    padding: 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
    background: $white;
    @media screen and (max-width: 480px) {
      width: 95%;
    }
  }
}

.qr-block {
  margin-top: 15px;
  width: 15%;
  @media screen and (max-width: 480px) {
    width: 20%;
  }
  .qr-block-canvas {
    margin-left: 14px;
  }
}

.mt-15 {
  margin-top: 15px;
}

.invite-public-link {
  color: $light-grey;
}

.contacts-box {
  background-color: white;
  border-radius: 5px;
  padding: 15px;
  border: 1px solid $light-grey;

  overflow: auto;
  width: 100%;
  overflow-x: hidden;
  &.list {
    max-height: 575px;
  }
  &.selected {
    max-height: 125px;
  }
}

.contact-item {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}

.contact-icon {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding-left: 0px;
  padding-top: 8px;
  display: block;
  background: $user-bubble;
  border: 0px solid;
  color: $dark-grey;
  text-align: center;
  font: 14px Arial, sans-serif;
  margin-right: 1rem;
  text-transform: uppercase;
}

.contact-details {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid $light-grey;
  width: 100%;
}

.contact-user {
  display: flex;
  flex-direction: column;
  width: 80%;
}

.contact-name {
  font-weight: bold;
  color: $dark-grey;
}

.contact-email {
  font-weight: normal;
  color: $light-grey;
  font-size: 0.8rem;
}

.contact-select {
  align-self: center;
}

.checked-circle {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: $dark-grey;
  border: 1px solid $dark-grey;
  color: white;
  text-align: center;
}

.participant-checked-circle {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: $light-grey;
  border: 1px solid $light-grey;
  color: white;
  text-align: center;
}

.empty-circle {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: white;
  border: 1px solid $dark-grey;
  color: white;
  padding: 6px;
}

.invitation-link {
  color: $grid-border;

  p {
    font-weight: $semi-bold-weight;
    margin-bottom: 0px;
  }
}

.invite-ack {
  color: $white;
  text-align: center;
  background-color: $primary-dark;
  padding: 10px;
}

.send-invitation-btn {
  width: 100%;
}

.display-left {
  float: left;
}

.display-right {
  cursor: pointer;
  color: $primary;
  float: right;
}

.selected-contact {
  margin-bottom: 40px;
}

.selected-contact-list {
  display: flow-root;
}

.btn-secondary:disabled {
  cursor: not-allowed;
}

.and-or {
  font-size: $big;
  text-align: center;
}

.text-end {
  text-align: end !important;
}

.inserted-contact {
  font-size: $very-small !important;
}

.remove-all {
  color: $mid-grey;
}

.btn-primary:disabled {
  cursor: not-allowed;
}

.select-contacts-link,
.invite-message-link {
  svg {
    vertical-align: -0.125em !important;
  }
}

.particpant-contact {
  color: $light-grey !important;
  span {
    color: $primary !important;
  }
}

.sidepanel-body {
  max-height: 100%;
  overflow: auto;
}

.invite-message-box {
  .invite-user-message-box {
    background: $very-light-grey;
    padding: 10px;
    color: $dark-grey;
    border-radius: 0.25rem;
  }
  .form-group {
    margin-bottom: 5px;
  }
  label {
    margin-bottom: 0px;
  }
}

.email-recommended {
  display: flex;
  [type='checkbox'].mandatory-email {
    width: 20px;
    height: 20px;
    vertical-align: middle;
    word-wrap: break-word;
    accent-color: $primary;
  }
  label {
    font-weight: $medium-weight;
  }
}

.recipients {
  display: flex;
  justify-content: space-between;
}

// ::v-deep .no-contacts {
//   span.custom-link {
//     color: $primary;
//     cursor: pointer;
//   }
// }

::v-deep .font-color-style {
  color: $grey !important;
}

::v-deep .navbar-nav.app-standardpage-tab {
  width: 100%;
}

::v-deep .nav-item {
  width: 50%;
  padding: 5px;
}

@media (max-width: 767px) {
  .contacts-box {
    &.list {
      max-height: 300px;
    }
  }
}

@media screen and (max-width: 480px) {
  .inserted-contact {
    font-size: $standard !important;
  }
  .k-links {
    // overflow: auto;
    white-space: nowrap;
  }
  .invite-section {
    /* max-height: 100%; */
  }
}
</style>
